import ContentLoader from "react-content-loader";

export default function TableLoader() {
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <ContentLoader width="100%" height="100%" backgroundColor="#f5f5f5" foregroundColor="#e0e0e0">
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="80" fill="#fffff" />
      </ContentLoader>
    </div>
  );
}
